export default {
  companyInformation: `company`,
  countries: "setup/countries",
  counties: "setup/counties",
  postcodes: `setup/postal-codes`,
  events: "setup/events",
  categories: "setup/categories",
  vendors: "setup/vendors",
  employees: "setup/employees",
  DIMENSIONS: "setup/dimensions",
  EXPENSECODES: "setup/expenseCodes",
  PAYMENTBASIS: "setup/paymentBasis",
  currencies: "events/setup/currencies",
};
